var DropDownOptions = require("components/utility/DropDownOptions");
var UploadStudentRoster = require("components/org/roster_upload/UploadStudentRoster");
var GoogleSync = require("components/org/roster_upload/GoogleSync");
var CleverSync = require("components/org/roster_upload/CleverSync");
var AddStudentsClassCode = require("components/org/roster_upload/AddStudentsClassCode");
var AddStudentsMethodSelect = require("components/org/roster_upload/AddStudentsMethodSelect");
var CurrentUser = require("lib/account/CurrentUser");
var Modal = require("components/utility/AltModal");
var LoadingButton = require("components/utility/LoadingButton");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var ReactionFeedback = require("components/support/ReactionFeedback");

var PendingTaskNotice = require("components/layout/PendingTaskNotice");

require("org/roster_upload/add_new_student_modal.scss");

class AddNewStudentModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = _.extend(this.getInitialTabState(props), {
			incrementKey: 0, 
			uploadProgressCount: null, uploadTotalCount: null,
			loading: false, showMultipleClass: false
		});
	}

	getInitialTabState(props) {
		props = props || this.props;

		if (CurrentUser.isGoogleSSOUser()) {
			var selectMethodStage = false;
			var currentTab = props.selectedTab || GOOGLE;
		} else if (CurrentUser.isCleverSSOUser()) {
			var selectMethodStage = false;
			var currentTab = props.selectedTab || CLEVER;
		} else {
			var selectMethodStage = true;
			var currentTab = props.selectedTab || MANUAL;
		}

		return { selectMethodStage, currentTab };
	}

	submitMultipleStudents(e) {
		$wr.nope(e)
		this.refs.errors.reset();

		var studentNames = [];
		var firstNames = [];
		var lastNames = [];
		var studentLists = [];
		var schoolOrgIDs = [];
		var gradeLevels = [];
		var shouldAddStudents = true

		function isNameMissing(namePairs) {
			return _.map(namePairs, (pair) => pair.length >= 1).includes(false)
		}
		function formatStudentLines(studentLine, studentLinesLength) {
			var splitLines = studentLine.split(",")
			if ((splitLines.length == 2) && (studentLinesLength > 1)) {
				splitLines.reverse();
				splitLines = [splitLines.join(" ")]
			}
			return splitLines
		}
		function formatStudentNames(studentNames, splitRegex) {
			var names = studentNames.value.split(splitRegex);
			return _.reject(names, (s) => {
				return s.trim().length == 0;
			});
		}
		_.each(this.props.studentLists, (studentList) => {
			var sid = studentList.id
			this.refs["errors_" + sid].reset();

			var studentNames = _.select(this.refs, (ref, key) => "student_names_" + sid == key)[0]
			var gradeLevel = _.select(this.refs, (ref, key) => "grade_level_" + sid == key)[0].value
			var firstNamesOnly = this.getFirstNameValue(sid)

			if (firstNamesOnly) {
				var singleFirstNames = formatStudentNames(studentNames, /[\n\t\,]/)

				firstNames = firstNames.concat(singleFirstNames)
				lastNames = lastNames.concat(singleFirstNames.map(() => { return $wr.Constants.FILLER_LAST_NAME }));
				studentLists = studentLists.concat(singleFirstNames.map(() => { return studentList.name }));
				schoolOrgIDs = schoolOrgIDs.concat(singleFirstNames.map(() => { return studentList.school_org_id }));
				gradeLevels = gradeLevels.concat(singleFirstNames.map(() => { return gradeLevel }));
			
			} else {
				var studentLines = formatStudentNames(studentNames, /[\n]/);

				var namePairs = []
				studentLines.forEach((studentLine) => {
					var splitLines = formatStudentLines(studentLine, studentLines.length)

					splitLines.forEach((student) => {
						if (student.trim().length == 0) { return }
						var namePair = student.trim().split(/[\t ]/);
						var lastName = namePair.pop();
						var firstName = namePair.join(" ").replace(/^\d+\.\s+/, '');
						if (namePair.length >= 1) {
							lastNames.push(lastName);
							firstNames.push(firstName);
						}
						namePairs.push(namePair)
						studentLists.push(studentList.name);
						schoolOrgIDs.push(studentList.school_org_id);
						gradeLevels.push(gradeLevel);
						
					})
				});
				if (isNameMissing(namePairs)) {
					shouldAddStudents = false
					this.refs["errors_" + sid].setError("Please enter a first and last name for each student.");
				} 
			}
		})

		var studentsData = {
			first_name: firstNames, last_name: lastNames,
			classroom: studentLists, grade_level: gradeLevels
		};

		if (_.compact(schoolOrgIDs).length) {
			studentsData.school_org_id = schoolOrgIDs;

		}

		if (shouldAddStudents) {
			if (lastNames.length == 0 || firstNames.length == 0) {
				this.refs.errors.setError("Please enter at least one student's name.");
			} else {
				this.setState({ loading: true, uploadProgressCount: 0,
					uploadTotalCount: studentsData.first_name.length });
				this.batchUploadStudents(studentsData, 0);
			}
		}
	}
	submitStudents(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		var studentNames = [];
		var firstNames = [];
		var lastNames = [];
		var studentLists = [];
		var gradeLevels = [];
		var missingFirstName = false;
		var missingLastName = false;

		var studentList = this.refs["student_list_name"].value;
		var sid = _.select(this.props.studentLists, (sl) => sl.name == studentList)[0].id
		var gradeLevel = this.refs["grade_level"].value;
		var firstNamesOnly = this.getFirstNameValue(0)

		if (!firstNamesOnly) {
			var studentLines = this.refs.student_names.value.split(/[\n]/);
			studentLines = _.reject(studentLines, (s) => {
				return s.trim().length == 0;
			});
			studentLines.map((studentLine) => {
				var splitLines = studentLine.split(",")
				if ((splitLines.length == 2) && (studentLines.length > 1)) {
					splitLines.reverse();
					splitLines = [splitLines.join(" ")]
				}
				splitLines.map((student) => {
					if (student.trim().length == 0) { return }
					var namePair = student.trim().split(/[\t ]/);
					var lastName = namePair.pop();
					var firstName = namePair.join(" ").replace(/^\d+\.\s+/, '');
					if (namePair.length >= 1) {
					lastNames.push(lastName);
					firstNames.push(firstName);
					}
					studentLists.push(studentList);
					gradeLevels.push(gradeLevel);
				})
			});
		} else {
			var firstNames = this.refs.student_names.value.split(/[\n\t\,]/);
			firstNames = _.reject(firstNames, (s) => {
				return s.trim().length == 0;
			});
			var lastNames = firstNames.map(() => { return $wr.Constants.FILLER_LAST_NAME });
			var studentLists = firstNames.map(() => { return studentList });
			var gradeLevels = firstNames.map(() => { return gradeLevel });
		}
		var missingName = gradeLevels.length != lastNames.length;

		var studentsData = { first_name: firstNames, last_name: lastNames,
			classroom: studentLists, grade_level: gradeLevels };

		if (missingName) {
			this.refs.errors.setError("Please enter a first and last name for each student.");
		} else if (lastNames.length == 0 || firstNames.length == 0) {
			this.refs.errors.setError("Please enter at least one student's name.");

		} 
		else {
			this.setState({ loading: true, uploadProgressCount: 0,
				uploadTotalCount: studentsData.first_name.length });
			this.batchUploadStudents(studentsData, 0);
		}
	}
	batchUploadStudents(studentsData, previousCount) {
		const batchSize = 5;
		const columns = ["first_name", "last_name", "classroom", "grade_level",  "school_org_id"];

		var theseStudents = {};
		var remainingStudents = {};
		_.each(columns, (col) => {
			if (studentsData[col]) {
				theseStudents[col] = _.first(studentsData[col], batchSize)
				remainingStudents[col] = _.rest(studentsData[col], batchSize)				
			}
		});

		var data = { students_data: theseStudents, no_background: true };

		if (this.props.effectiveUserID) {
			data["effective_user_id"] = this.props.effectiveUserID;
		}

		CurrentUser.api().postRosters(data, $wr.apiHandler((response) => {
			if (remainingStudents.first_name.length > 0) {
				var totalCount = previousCount + response.student_count;
				this.setState({ uploadProgressCount: totalCount });
				this.batchUploadStudents(remainingStudents, totalCount)

			} else {
				this.setState({ loading: false, incrementKey: this.state.incrementKey + 1,
					uploadProgressCount: null, uploadTotalCount: null });
				this.onRosterUpload(previousCount + response.student_count, true);
			}
			Mycroft.newEvent({ category: "StudentRoster", action: "add-students", label: this.state.currentTab });
		}));
	}

	show() {
		this.refs.modal.show();
		LuckyOrangeClient.tagComponent("AddNewStudentModal");
		setTimeout(() => {
			$(".studentsTextArea").focus();
		}, 100)
	}

	onRosterUpload(studentCount, alreadyLoaded, pendingTask) {
		$(window.document).trigger("onboarding-trigger-add-students");
		this.showUploadNotification(studentCount, alreadyLoaded, pendingTask);	
		this.refs.modal.hide();

		if (this.props.onAddedStudents) {
			this.props.onAddedStudents();
		}
	}

	showUploadNotification(studentCount, alreadyLoaded, pendingTask) {
		var title = $wr.pluralize("Student", studentCount) + " Added";
		var studentText = studentCount + " student " + $wr.pluralize("account", studentCount);

		if (alreadyLoaded) {
			var text = "You added " + studentText + "!";				
		} else {
			var text = "You are adding " + studentText + "! Hang tight, this could take a few minutes.";				
		}

		window.wrNotifications.triggerDropDownNotification({ title: title,
			text: text, icon: "ok-circle" }, 4000);

		// This will automatically trigger the notice for manual addition
		window.wrNotifications.loadPendingTask(pendingTask);
	}

	changeTab(tabKey) {
		this.setState({ currentTab: tabKey, selectMethodStage: false }, () => {
			// Trigger modal resize
			$(window).trigger("resize");
		});
	}

	getTabName(tabKey) {
		if (tabKey == MANUAL) {
			return "Manual";
		} else if (tabKey == CODE) {
			return "Class Code";
		} else if (tabKey == UPLOAD) {
			return "CSV/Excel Upload";
		} else if (tabKey == GOOGLE) {
			return "Google Classroom";
		} else if (tabKey == CLEVER) {
			return "Clever";
		}
	}
	getTabOptions() {
		var tabOptions = METHOD_OPTIONS;

		// remove Google if using Clever, otherwise remove Clever
		if (CurrentUser.isCleverSSOUser()) {
			tabOptions = _.without(tabOptions, GOOGLE);
		} else {
			tabOptions = _.without(tabOptions, CLEVER);
		}

		// also remove Google & clever option for non teacherAdmins
		if (!CurrentUser.isTeacherAdmin()) {
			tabOptions = _.without(tabOptions, GOOGLE);
			tabOptions = _.without(tabOptions, CLEVER);
		}

		if (!(CurrentUser.isTeacherAdmin() || CurrentUser.isWizard())) {
			tabOptions = _.without(tabOptions, UPLOAD);
		}

		return tabOptions;
	}
	renderToggleButton(tabKey) {
		var toggleClassName = "btn btn-default";
		if (this.state.currentTab == tabKey) {
			toggleClassName += " active";
		}
		return (
			<label className={ toggleClassName } key={ "label-" + tabKey }
				onClick={ this.changeTab.bind(this, tabKey) }>
				<input type="radio" name="viewOptions" /> { this.getTabName(tabKey) }
			</label>
		);
	}
	renderToggleOptions() {
		return _.map(this.getTabOptions(), (tabKey) => {
			return this.renderToggleButton(tabKey);
		});
	}

	onHide() {
		// this.props.onModalClose;

		this.setState(this.getInitialTabState());
	}
	renderNoLastNameOption(studentListId) {
		return (
			<label className="normal firstNameOnly">
				<input type="checkbox"
					key={studentListId}
					ref={"first_name_" + studentListId}
					onChange={ () => {this.setState({})} } />

				{" "}Use student first names only
			</label>
		);
	}
	selectRef(label, studentListId) {
		return _.select(this.refs, (ref, key) => label + studentListId == key)[0]
	}
	getFirstNameValue(studentListId) {
		var firstNameValue = this.selectRef("first_name_", studentListId)
		return firstNameValue ? firstNameValue.checked : false
	}
	renderMultipleManualClassForm() {
		return this.props.studentLists.map((studentList) => {
			var firstNameValue = this.getFirstNameValue(studentList.id)
			var placeholder = firstNameValue ? "Marcus, Tanya" : "Marcus Gamry, Tanya Wilkins";

			var gradeLevelSelector = (
				<div className="gradeLevelContainer">
					<span className="inputFieldTitle">Grade</span>
					<select name="grade_level" ref={"grade_level_" + studentList.id}
						className="form-control" defaultValue={ studentList.grade_level }>
						{ DropDownOptions.Select.GradeLevels() }
					</select>
				</div>	
			)
			if (!this.state.showMultipleClass && 
				this.props.defaultStudentList && 
				studentList.id != this.props.defaultStudentList.id) {
				var hidden = true
			}
			return(
				<div className="manualClass" key={studentList.id} hidden={hidden}>
					<div className="className">
						{ studentList.name }
					</div>
					<form onSubmit={ this.multipleSubmitStudents } className="textAreaForm">
						<span className="inputFieldTitle">Names</span>
						<textArea className="form-control studentsTextArea" rows="2" cols="20"
							autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
							placeholder={ placeholder } ref={"student_names_" + studentList.id} />

					</form>
					<div className="rightOps">
						{ gradeLevelSelector }
						{ this.renderNoLastNameOption(studentList.id) }
					</div>
					<ErrorDisplay ref={"errors_"+ studentList.id} />
				</div>
			)
		})
	}
	renderManualClassForm() {
		var defaultStudentList = this.props.defaultStudentList;
		if (this.props.studentLists.length > 0) {
			if (defaultStudentList) {
				var defaultName = defaultStudentList.name;
				var defaultGradeLevel = defaultStudentList.grade_level; 
				var sid = defaultStudentList.id
			} else {
				var studentList = this.props.studentLists[0];
				var defaultGradeLevel = studentList.grade_level    
				var defaultName = studentList.name;
				var sid = studentList.id
			}

			if (defaultStudentList) {
				var defaultName = defaultStudentList.name;
				if(defaultStudentList.grade_level == undefined) {
					var defaultGradeLevel = this.props.studentLists[0].grade_level
				} else {
					var defaultGradeLevel = defaultStudentList.grade_level;
				}
			}

			var firstNameValue =this.getFirstNameValue(sid)
			var placeholder = firstNameValue ? "Marcus, Tanya" : "Marcus Gamry, Tanya Wilkins";

		}

		var studentListOptions = this.props.studentLists.map((studentList) => {
			return (
				<option value={ studentList.name } key={ studentList.id }>
					{ studentList.name }
				</option>
			)
		});
		var studentListSelector = (
			<div className="studentListContainer">
				<span className="inputFieldTitle">Class</span>
				<select ref="student_list_name" defaultValue={ defaultName } 
					className="form-control">
					{ studentListOptions }
				</select>
			</div>	
		)
		var gradeLevelSelector = (
			<div className="gradeLevelContainer">
				<span className="inputFieldTitle">Grade</span>
				<select name="grade_level" ref="grade_level"
					className="form-control" defaultValue={ defaultGradeLevel }>
					{ DropDownOptions.Select.GradeLevels() }
				</select>
			</div>	
		)

		return (
			<div className="manualClass">
				<form onSubmit={ this.originalSubmitStudents } className="textAreaForm">
					<span className="inputFieldTitle">Names</span>
					<textArea className="form-control studentsTextArea" rows="2" cols="20"
						autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
						placeholder={ placeholder } ref="student_names" />
				</form>
				<div className="rightOps">
					{ gradeLevelSelector }
					{ studentListSelector }
					{ this.renderNoLastNameOption(0) }
				</div>
			</div>
		)
	}

	getDefaultGradeLevel() {
		var defaultStudentList = this.props.defaultStudentList;
		var defaultGradeLevel = "5"
		if (this.props.studentLists.length > 0) {
			if (defaultStudentList) {
				defaultGradeLevel = defaultStudentList.grade_level; 
			} else {
				var studentList = this.props.studentLists[0];
				defaultGradeLevel = studentList.grade_level    
			}

			if (defaultStudentList) {
				if(defaultStudentList.grade_level == undefined) {
					defaultGradeLevel = this.props.studentLists[0].grade_level
				} else {
					defaultGradeLevel = defaultStudentList.grade_level;
				}
			}
		}
		return defaultGradeLevel	
	}
	render() {
		

		var toggleOptions = (
			<div className="text-center">
				<div className="btn-group smallObject uploadViewToggle" data-toggle="buttons">
					{ this.renderToggleOptions() }
				</div>
			</div>
		);

		if (this.state.currentTab == MANUAL) {

			if (CurrentUser.isCleverSSOUser()) {
				var addStudentsWarning = (
					<div className="addWarning">
						<p>
							<strong className="orangeBold">Wait a moment! Your
							account appears to be linked to Clever.</strong> As your students log
							in through Clever, they will automatically be added to your account.
						</p>
						<p>
							If you add student accounts through this page, you may
							end up with duplicate accounts. Proceed with caution.
						</p>
					</div>
				)
			} else if (window.wrNotifications && window.wrNotifications.getPendingTask) {
				var task = window.wrNotifications.getPendingTask();

				if (task == PendingTaskNotice.UPLOADING_STUDENTS) {
					var addStudentsWarning = (
						<div className="addWarning">
							<p>
								<strong className="orangeBold">Wait a moment! Your student roster
								is currently being uploaded.</strong> If you add more students right now,
								you may end up with duplicate accounts. Proceed with caution.
							</p>
						</div>
					);
				} else if (task == PendingTaskNotice.GOOGLE_SYNC) {
					var addStudentsWarning = (
						<div className="addWarning">
							<p>
								<strong className="orangeBold">Wait a moment! Your account
								is currently syncing with Google.</strong> If you add more students
								right now, you may end up with duplicate accounts. Proceed with caution.
							</p>
						</div>
					);
				} else if (task == PendingTaskNotice.CLEVER_SYNC) {
					var addStudentsWarning = (
						<div className="addWarning">
							<p>
								<strong className="orangeBold">Wait a moment! Your account
								is currently syncing with Clever.</strong> If you add more students
								right now, you may end up with duplicate accounts. Proceed with caution.
							</p>
						</div>
					);
				}
			}

			var modalClass = " manualUploadView";
			var form = this.renderMultipleManualClassForm()
			var submitFunction = this.submitMultipleStudents.bind(this)

			var toggleMultiple = (
				<div className="mutlipleClassToggle"> 
					<a onClick={() => this.setState({showMultipleClass: !this.state.showMultipleClass})}>
						{ this.state.showMultipleClass?  "Hide other classes" : "Add to other classes"}
					</a>
				</div>
			);

			if (!this.state.selectMethodStage) {
				var actionButtons = (
					<div className="actionButtons">
						<ReactionFeedback where="add-new-student-modal" 
							textOnly={false} 
							title={"Was it easy to add your students?"}
							placeholder={"Your feedback goes here..."}
							component_position = { ReactionFeedback.POSITION_MODAL_BOTTOM_LEFT }
							popover_position={ ReactionFeedback.POSITION_BOTTOM_LEFT }
						/>
						<LoadingButton className="btn buttonSuccess" loading={ this.state.loading }
							text="Add Students" onClick={ submitFunction } />
					</div>
				);
			}

			if (this.state.uploadProgressCount != undefined) {
				var uploadProgress = (
					<div className="progressIndicator">
						{ this.state.uploadProgressCount } of { this.state.uploadTotalCount } uploaded...
					</div>
				);
			}

			
			var tabContent = (
				<div className="manualContainer">
					{ addStudentsWarning }
					<ErrorDisplay ref="errors" />
					<p className="textAreaInstructions">
						Type or paste students' names here. For multiple students, use separate
						lines or a comma. For multiple grades or classes, repeat this process.
					</p>
					{ form }
					{ uploadProgress }
					{ toggleMultiple }
				</div>
			)

		} else if (this.state.currentTab == UPLOAD) {
			var modalClass = " fileUploadView moreWideModal";
			var tabContent = (
				<div className="uploadView">
					<UploadStudentRoster
						afterCreate={this.props.onAddedStudents}
						onUpload={this.onRosterUpload}
						effectiveUserID={ this.props.effectiveUserID } />
				</div>
			);

		} else if (this.state.currentTab == CODE) {
			var modalClass = " classCodeView";
			var tabContent = (
				<AddStudentsClassCode studentLists={ this.props.studentLists } />
			)

		} else if (this.state.currentTab == GOOGLE) {
			var modalClass = " ssoView";
			var currentStudentLists = this.props.studentLists;
			
			var tabContent = (
				<GoogleSync onUpload={ this.onRosterUpload } currentStudentLists={ currentStudentLists } />
			);

		} else if (this.state.currentTab == CLEVER) {
			var modalClass = " ssoView";
			var tabContent = (
				<CleverSync onUpload={ this.onRosterUpload } />
			);

		} else {
			throw "unknown currentTab: " + this.state.currentTab;
		}

		if (this.state.selectMethodStage) {
			var innerContent = (
				<AddStudentsMethodSelect methodOptions={ this.getTabOptions() }
					onMethodSelect={ this.changeTab } />
			);
		} else {
			var innerContent = (
				<div key={ this.state.incrementKey }>
					{ toggleOptions }
					{ tabContent }
				</div>
			);
		}

		return (
			<div>
				<Modal className={"studentRosterModal addNewStudentModal" + modalClass}
					headerText="Add Students" ref="modal"
					onHide={ this.onHide }
					actionButtons={ actionButtons }>
					<div className="innerWrap">
						{ innerContent }
					</div>
				</Modal>
			</div>
		)
	}

	componentDidMount() {
		$("#addNewStudentModal").keypress((e) => {
			if ($(".first_name").val() != "") {
		  		this.refs.errors.reset();
		  	}
		});
		$("#addNewStudentModal").keypress((e) => {
			if ($(".last_name").val() != "") {
		  		this.refs.errors.reset();
		  	}
		});
	}
};

var MANUAL = "manual";
var CODE = "class-code";
var UPLOAD = "upload";
var GOOGLE = "google-classroom";
var CLEVER = "clever";

// in the order we want them displayed
var METHOD_OPTIONS = [MANUAL, CODE, UPLOAD, GOOGLE, CLEVER];

AddNewStudentModal.propTypes = StrictPropTypes({
	defaultStudentList: PropTypes.object,
	onModalClose: PropTypes.func,
	onAddedStudents: PropTypes.func,
	studentLists: PropTypes.array,
	selectedTab: PropTypes.string,
	effectiveUserID: PropTypes.number,
});

module.exports = AddNewStudentModal;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AddNewStudentModal.js